import { Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class UtilService {

  constructor() { }

  public goToByScroll(id) {
    $('html, body').animate({ scrollTop: $(id).offset().top - 56 }, 1000);
  }

  public dateToHtmlInputDate(date: Date): string {
    function pad(v: number): string {
      if (v < 10)
        return '0' + v;
      else
        return v.toString();
    }

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  }

  public htmlInputDateToDate(date: string): Date {
    // [0]:year, [1]:month, [2]:day
    const segments = date.split('-').map(s => parseInt(s, 10));
    if (segments.length < 3)
      throw new Error('Could not parse date string with ' + segments.length + ' segments');

    return new Date(segments[0], segments[1] - 1, segments[2]);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/util.service.ts